export default __webpack_public_path__ + "static/media/176.b3cfc11b.png";